import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { DateTime } from 'luxon';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CropHealthViewModel } from '@/app/proxy/proxies';

@Component({
  selector: 'app-crop-health-map-calendar-select-date-modal',
  imports: [SharedModule],
  templateUrl: './crop-health-map-calendar-select-date-modal.component.html',
  styleUrl: './crop-health-map-calendar-select-date-modal.component.less',
})
export class CropHealthMapCalendarSelectDateModalComponent implements OnChanges {
  @Input() availableDates: DateTime<boolean>[] = [];
  @Input() selectionMode: 'single' | 'multiple' | 'range' = 'single';
  @Input() cropHealthData: CropHealthViewModel;
  selectedDate: any;
  today = new Date();
  disabledDates: Date[] = [];

  viewMode: 'month' | 'year' | 'day' = 'day';

  @ViewChild('myCalendar') calendar: ElementRef | any;

  constructor(private dialogRef: DynamicDialogRef) { }

  ngOnChanges(): void { }

  isAllowedDate(date: { day: number; month: number; year: number }): boolean {
    const d = new Date(date.year, date.month, date.day);
    return this.availableDates
      .some((e) => e.hasSame(DateTime.fromJSDate(d), 'day'));
  }

  onChangeDate() {
    const isAllowedDate = this.availableDates
      .some((e) => e.hasSame(DateTime.fromJSDate(this.selectedDate), 'day'));
    if (!isAllowedDate) {
      this.selectedDate = undefined;
    }
  }

  apply() {
    this.dialogRef.close(this.selectedDate);
  }

  close() {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // Delay to wait for calendar popup to render
      const calendarEl: HTMLElement = document.querySelector('.p-datepicker')!;
      if (!calendarEl) return;

      const yearButton = calendarEl.querySelector('.p-datepicker-select-year');
      const monthButton = calendarEl.querySelector('.p-datepicker-select-month');
      const monthSelected = calendarEl.querySelector('.p-datepicker-month');

      if (yearButton) {
        yearButton.addEventListener('click', () => {
          console.log('Year view activated');
          this.viewMode = 'year';
        });
      }

      if (monthButton) {
        monthButton.addEventListener('click', () => {
          console.log('Month view activated');
          this.viewMode = 'month';
        });
      }

      if (monthSelected) {
        monthButton.addEventListener('click', () => {
          console.log('Month view activated');
          this.viewMode = 'day';
        });
      }
    }, 100); // Small delay to ensure DOM is present
  }
}
